import styled from "@emotion/styled";
import classNames from "classnames";
import Popper, { Placement, PopperOptions } from "popper.js";
import * as React from "react";

import { DesignToken, ShadowToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

interface IStyledPopupProps {
  contentZIndex?: number;
  childrenZIndex?: number;
}

const StyledPopup = styled.div<IStyledPopupProps>`
  z-index: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.childrenZIndex || 2100
  };

  .popper-popup {
    position: absolute;
    z-index: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.contentZIndex || 2000
    };
    display: none;

    &.show {
      display: block;
    }
  }
`;

export const StyledPopperContent = styled.div`
  min-width: 215px;
  color: ${withVar(DesignToken.ContentBasicPrimary)};
  background-clip: padding-box;
  font-weight: 400;

  border-radius: 4px;
  background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
  box-shadow: ${withVar(ShadowToken.PopOver)};
`;

interface IPopperContainerProps extends IStyledPopupProps {
  children: React.ReactNode;
  content: React.ReactChild;
  placement: Placement;
  offset: number | string; // https://popper.js.org/popper-documentation.html#modifiers..offset.offset
  initiallyVisible?: boolean;

  onToggled?: (isVisible: boolean) => void;
}

interface IPopperContainerState {
  isVisible: boolean;
}

export default class PopperContainer extends React.Component<IPopperContainerProps, IPopperContainerState> {
  // @ts-expect-error TS(2416): Property 'state' in type 'PopperContainer' is not ... Remove this comment to see the full error message
  state = {
    isVisible: this.props.initiallyVisible,
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentDidMount() {
    if (this.state.isVisible) {
      this.initializePopper();
    }
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentDidUpdate(_prevProps: IPopperContainerProps, prevState: IPopperContainerState) {
    const isShown = !prevState.isVisible && this.state.isVisible;
    const isHidden = prevState.isVisible && !this.state.isVisible;

    if (isShown) {
      this.initializePopper();
    }

    if (isHidden) {
      this.removeEventHandlers();
    }
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentWillUnmount() {
    if (this.popperInstance) {
      this.popperInstance.destroy();
      // @ts-expect-error TS(2322)
      this.popperInstance = null;
    }

    this.removeEventHandlers();
  }

  private get popperOptions(): PopperOptions {
    return {
      placement: this.props.placement,
      modifiers: {
        offset: {
          offset: this.props.offset,
        },
        flip: {
          enabled: true,
        },
      },
    };
  }

  private referenceElementRef: React.RefObject<HTMLDivElement> = React.createRef();
  private contentRef: React.RefObject<HTMLDivElement> = React.createRef();
  // @ts-expect-error TS(2564)
  private popperInstance: Popper;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private initializePopper = () => {
    if (!this.popperInstance) {
      // @ts-expect-error TS(2345)
      this.popperInstance = new Popper(this.referenceElementRef.current, this.contentRef.current, this.popperOptions);
    }

    this.addEventHandlers();
    this.popperInstance.scheduleUpdate();
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private addEventHandlers = () => {
    document.addEventListener("click", this.handleDocumentClick);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private removeEventHandlers = () => {
    document.removeEventListener("click", this.handleDocumentClick);
  };

  private handleDocumentClick = (event: Event): void => {
    if (this.contentRef.current && !this.contentRef.current.contains(event.target as Node)) {
      this.handleToggle();
    }
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private handleToggle = () => {
    this.setState(
      prevState => ({
        isVisible: !prevState.isVisible,
      }),
      () => {
        if (this.props.onToggled) {
          // @ts-expect-error TS(2345): Argument of type 'boolean | undefined' is not assi... Remove this comment to see the full error message
          this.props.onToggled(this.state.isVisible);
        }
      }
    );
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  toggle = () => {
    this.handleToggle();
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { isVisible } = this.state;
    const { contentZIndex, childrenZIndex } = this.props;
    return (
      <StyledPopup contentZIndex={contentZIndex} childrenZIndex={childrenZIndex}>
        <div ref={this.referenceElementRef} onClick={this.handleToggle}>
          {this.props.children}
        </div>

        <div className={classNames("popper-popup", { show: isVisible })} ref={this.contentRef}>
          {this.props.content}
        </div>
      </StyledPopup>
    );
  }
}
